<template>
  <div>

    <validation-observer ref="simpleRulesEntry">
      <b-card>
        <b-row>
          <b-col>
            <b-media no-body>
              <b-media-aside
                class="mr-2"
              >
                <b-avatar
                  size="48"
                  variant="light-info"
                >
                  <feather-icon
                    size="24"
                    icon="BoxIcon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ purchaseOffers.title }}
                </h4>
                <b-card-text class="font-small-3 mb-0">
                  Onaylı Satınalma Teklifi Stok Girişi
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-card>
      <div
        v-for="(key,index) in dataItem"
        :key="index"
      >
        <b-card
          no-body
        >
          <b-card-header>
            <b-card-title>{{ (index + 1) }}.Kayıt</b-card-title>
            <b-button
              variant="outline-danger"
              class="btn-icon rounded-circle"
              @click="removeRow(index)"
            >
              <feather-icon icon="XIcon" />
            </b-button>
          </b-card-header>
          <b-card-body>
            <quick-stock-line-form
              :item-key="index"
              :price-required="false"
              :partial-entry="true"
              :partial-entry-amount="Number(dataItem[index].entry_amount_orginal)"
            />
          </b-card-body>
        </b-card>
      </div>
      <b-row>
        <b-col
          cols="12"
          md="12"
          class="mb-2"
        >
          <b-form-checkbox
            v-model="partial"
          >Talebe ait stok girişini sonlandır.</b-form-checkbox>
        </b-col>
        <b-col
          class="text-left"
        >
          <b-button
            variant="primary"
            class="text-left"
            :disabled="dataItem.submitStatus"
            @click="EntrySubmitData"
          >
            <feather-icon icon="SaveIcon" />

            Kaydet
          </b-button>
        </b-col>
        <b-col class="float-right">
          <b-button
            variant="success"
            class="text-left ml-2 float-right"
            @click="addRow()"
          >
            <feather-icon icon="PlusIcon" />
            Yeni Satır
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver } from 'vee-validate'
import {
  BButton, BCard, BCardHeader, BCardTitle, BCardBody, BRow, BCol, BMediaBody, BMediaAside, BMedia, BAvatar, BCardText, BFormCheckbox,
} from 'bootstrap-vue'
import QuickStockLineForm from '@/views/Admin/Stocks/Components/AddPurchaseOffersQuickentryStockLineForm.vue'

export default {
  name: 'QuickStocksAddLines',
  components: {
    BCardText,
    BAvatar,
    BMedia,
    BMediaAside,
    BMediaBody,
    QuickStockLineForm,
    BButton,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormCheckbox,
  },
  data() {
    return {
      entry: null,
      partial: true,
    }
  },
  computed: {
    stockData() {
      return this.$store.getters['stocks/dataItem']
    },
    dataItem() {
      return this.$store.getters['stockLines/dataItem']
    },
    saveData() {
      return this.$store.getters['stockLines/dataSaveStatus']
    },
    purchaseOffers() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.dataItem.submitStatus = false
        this.$store.commit('stockLines/RESET_DATA_ITEM_QUICK')
        this.$router.push('/app/stocks/purchase-offers-in')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.$store.commit('stockLines/RESET_DATA_ITEM_QUICK')
    this.dataItem[0].id_purchase_offers = this.$route.params.id_purchase_offers
    this.getProject()
  },
  methods: {
    EntrySubmitData() {
      this.$refs.simpleRulesEntry.validate().then(success => {
        if (success) {
          this.dataItem.submitStatus = true
          this.$store.dispatch('stockLines/batchInsert', this.dataItem)
            .then(res => {
              if (res.status) {
                // Kısmi giriş ile aktif et.
                if (this.partial) {
                  this.$store.dispatch('purchaseOffers/saveData', {
                    id: this.purchaseOffers.id,
                    id_purchase_offer_status: 8,
                  })
                }
              }
            })
        } else {
          this.showToast({
            variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: 'Tüm alanları doldurmalısınız.',
          })
        }
      })
    },
    addRow() {
      this.dataItem.push({
        id: null,
        entry_amount: null,
        output_amount: null,
        price: null,
        invoice_number: null,
        id_purchase_offers: this.$route.params.id_purchase_offers,
        id_warehouses: null,
        id_suppliers: this.purchaseOffers.id_confirmed_suppliers,
        id_stocks: null,
        id_users: null,
        submitData: false,
      })
    },
    removeRow(key) {
      if (this.dataItem.length > 1) {
        this.dataItem.splice(key, 1)
      } else {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: 'Daha fazla satır silemezsiniz.',
        })
      }
    },
    getStockData(stockId) {
      this.$store.dispatch('stocks/getDataItem', stockId)
    },
    getProject() {
      this.$store.dispatch('purchaseOffers/getDataItem', { id: this.$route.params.id_purchase_offers })
        .then(res => {
          if (res) {
            this.$store.dispatch('purchaseOfferItems/getDataList', {
              select: [
                '0 AS id',
                'purchase_offer_items.amount AS entry_amount',
                'purchase_offer_items.amount AS entry_amount_orginal',
                'stock_lines.entry_amount AS entried_amount',
                '0 AS output_amount',
                '0 AS price',
                '0 AS invoice_number',
                'purchase_offer_items.id_purchase_offers AS id_purchase_offers',
                '0 AS id_warehouses',
                '0 AS id_suppliers',
                'purchase_offer_items.id_stocks AS id_stocks',
                '0 AS id_users',
                '0 AS submitData',

              ],
              where: {
                'purchase_offer_items.id_purchase_offers': res.id,
              },
            }).then(item => {
              if (item.length > 0) {
                // eslint-disable-next-line no-param-reassign
                item = item.filter(row =>
                  // entry_amount <= entried_amount ve entried_amount dolu ise filtrele
                  !(row.entry_amount <= Number(row.entried_amount) && Number(row.entried_amount)))
                item.forEach((row, index) => {
                  // eslint-disable-next-line no-param-reassign
                  item[index].id = null
                  // eslint-disable-next-line no-param-reassign
                  // item[index].entry_amount = null
                  if (item[index].entried_amount) {
                    if (item[index].entry_amount > item[index].entried_amount) {
                      // eslint-disable-next-line no-param-reassign,operator-assignment
                      item[index].entry_amount = item[index].entry_amount - item[index].entried_amount
                    }
                    // eslint-disable-next-line no-param-reassign,operator-assignment
                    item[index].entry_amount_orginal = item[index].entry_amount_orginal - item[index].entried_amount
                  }
                  // eslint-disable-next-line no-param-reassign
                  item[index].output_amount = null
                  // eslint-disable-next-line no-param-reassign
                  item[index].price = null
                  // eslint-disable-next-line no-param-reassign
                  item[index].invoice_number = null
                  // eslint-disable-next-line no-param-reassign
                  item[index].id_warehouses = null
                  // eslint-disable-next-line no-param-reassign
                  item[index].id_suppliers = this.purchaseOffers.id_confirmed_suppliers
                  // eslint-disable-next-line no-param-reassign
                  item[index].id_users = null
                  // eslint-disable-next-line no-param-reassign
                  item[index].submitData = false
                  // eslint-disable-next-line no-param-reassign
                  item[index].notes = `${this.purchaseOffers.onumber} numaralı teklif talebi ile eklenmiştir.`
                  // eslint-disable-next-line no-param-reassign
                  this.$store.commit('stockLines/SET_DATA_ITEM', item)
                })
              }
            })
          }
        })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
